import React from "react";
import { Star } from "lucide-react";

export default function ReviewCard({ review }) {
  const initials = review.name.split(" ").map((n) => n[0]).slice(0, 2).join("");
  return (
    <article data-testid="review-card" className="bg-ivory border border-charcoal/10 p-6 md:p-8">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-full bg-burgundy text-ivory flex items-center justify-center font-serif">{initials}</div>
        <div>
          <div className="font-medium">{review.name}</div>
          <div className="text-[11px] tracking-[.2em] uppercase text-charcoal/50">Recenze Google</div>
        </div>
      </div>
      <div className="flex gap-0.5 mb-4">
        {Array.from({ length: review.rating }).map((_, i) => (
          <Star key={i} size={16} className="text-gold fill-gold" />
        ))}
      </div>
      <p className="text-charcoal/80 leading-relaxed">„{review.text}"</p>
    </article>
  );
}
